<template>
  <div style="height: 100vh;">
    <div
      id="map"
      style="position:fixed; z-index: 0;"
      :class="{ collapsed: isCollapsed }"
    />
    <div
      id="folding_tab"
      class="px-4"
      :class="{ collapsed: isCollapsed }"
    >
      <div
        class="tab mx-auto"
        @click="isCollapsed=false"
      />
      <div style="height: calc(100% - 15px);">
        <div v-if="step==1">
          <address-browser-component @get-data-address="handleGetAddress" />
        </div>
        <div
          v-else-if="step==2"
          class=""
          style="display: flex; flex-direction: column; height: 100%;"
        >
          <div style="flex-grow: 1; overflow: auto;">
            <div class="m-0 mt-4 ">
              <i
                class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
                style="color:#011638; border-radius: 1000px; "
                @click="step--"
              />
              <span
                style="color:#011638; font-weight: 600; font-size: 1.2rem;"
                class="ms-3"
              >Disponibilidad</span>
            </div>
            <div class="row m-0 mt-3">
              <div class="col">
                <span style="color:#56647A;font-size: 0.9rem; font-weight: 600;">
                  <i
                    class="fa-solid fa-location-dot me-2"
                    style="font-size: 1.2rem;"
                  />
                  UBICACIÓN
                </span>
                <p
                  class="mb-0"
                  style="color:#011638"
                >
                  {{ input.address.address }}
                </p>
                <p
                  class="mb-0"
                  style="color:#011638"
                >
                  {{ input.address.city }}
                </p>
              </div>
            </div>
            <div
              class="row m-0 mt-2"
              style="color:#011638"
            >
              <p
                style="color:#56647A"
                class="mb-1"
              >
                Lunes a viernes
              </p>
              <div class="row m-0 bg-white rounded-top-4 py-3">
                <span class="col">Día entero (24h)</span>
                <div class="form-check form-switch col-2 d-flex justify-content-end">
                  <input
                    id="flexSwitchCheckDefault"
                    v-model="input.weekend_full_day"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                  >
                </div>
              </div>
              <div class="row m-0 bg-white rounded-bottom-4 py-3">
                <span class="col">Franja horaria</span>
                <time-component
                  ref="time_component"
                  class="col"
                  @get-data-horas="handleGetDataHoras"
                />
              </div>
            </div>
            <div
              class="row m-0 mt-2"
              style="color:#011638"
            >
              <p
                style="color:#56647A"
                class="mb-1"
              >
                Sábado y domingo
              </p>
              <div class="row m-0 bg-white rounded-3 py-3">
                <span class="col">Día entero (24h)</span>
                <div class="form-check form-switch col-2 d-flex justify-content-end">
                  <input
                    id="flexSwitchCheckDefault"
                    v-model="input.weekend_full_day"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            style="height: 50px;"
            class="mt-3"
          >
            <button
              class="btn py-2 w-100 rounded-3"
              style="background-color: #011638; font-size: 1.1rem;font-weight: 600; color: white"
              @click="step++"
            >
              <span>Siguiente <i
                class="fa-solid fa-angle-right ms-1"
                style="font-size: 1rem;"
              /></span>
            </button>
          </div>
        </div>
        <div
          v-else-if="step==3"
          class=""
          style="display: flex; flex-direction: column; height: 100%;"
        >
          <div
            style="flex-grow: 1; overflow-y: auto; overflow-x: hidden;"
          >
            <div class="m-0 mt-4 ">
              <i
                class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
                style="color:#011638; border-radius: 1000px; "
                @click="step--; $nextTick(() => { if ($refs.time_component) { $refs.time_component.CambiarHoras(input.time); } })"
              />
              <span
                style="color:#011638; font-weight: 600; font-size: 1.2rem;"
                class="ms-3"
              >Tamaño</span>
            </div>
            <div class="row m-0 mt-3">
              <div class="col">
                <span style="color:#56647A;font-size: 0.9rem; font-weight: 600;">
                  <i
                    class="fa-solid fa-location-dot me-2"
                    style="font-size: 1.2rem;"
                  />
                  UBICACIÓN
                </span>
                <p
                  class="mb-0"
                  style="color:#011638"
                >
                  C/ Pintor Cortina 41...
                </p>
                <p
                  class="mb-0"
                  style="color:#011638"
                >
                  Valencia
                </p>
              </div>
              <div class="col">
                <span style="color:#56647A;font-size: 0.9rem; font-weight: 600;">
                  <i
                    class="fa-regular fa-clock me-2"
                    style="font-size: 1.2rem;"
                  />
                  HORARIO
                </span>
                <p
                  class="mb-0"
                  style="color:#011638"
                >
                  L-V: {{ input.time.startTime }}h-{{ input.time.endTime }}h
                </p>
                <p
                  class="mb-0"
                  style="color:#011638"
                >
                  S-D: 24h
                  <i
                    v-if="input.weekend_full_day"
                    class="fa-solid fa-check ms-2 text-success"
                  />
                  <i
                    v-else
                    class="fa-solid fa-x ms-2 text-danger"
                  />
                </p>
              </div>
            </div>
            <div class="mt-3 ms-2 bg-white ps-3 rounded-4">
              <div
                class="row m-0"
                @click="input.vehicle_size='small'"
              >
                <p
                  class="py-3 mb-0 col-10"
                  style="color:#8E97A7"
                >
                  Coche pequeño (3,6 x 1,6m)
                </p>
                <i
                  v-if="input.vehicle_size=='small'"
                  class="fa-solid fa-check col-2 d-flex align-items-center"
                  style="color:#15E0DD"
                />
              </div>
              <hr class="my-0">
              <div
                class="row m-0"
                @click="input.vehicle_size='medium'"
              >
                <p
                  class="py-3 mb-0 col-10"
                  style="color:#8E97A7"
                >
                  Coche mediano (4,5 x 1,8m)
                </p>
                <i
                  v-if="input.vehicle_size=='medium'"
                  class="fa-solid fa-check col-2 d-flex align-items-center"
                  style="color:#15E0DD"
                />
              </div>
              <hr class="my-0">
              <div
                class="row m-0"
                @click="input.vehicle_size='large'"
              >
                <p
                  class="py-3 mb-0 col-10"
                  style="color:#8E97A7"
                >
                  Coche grande (5,0 x 1,9m)
                </p>
                <i
                  v-if="input.vehicle_size=='large'"
                  class="fa-solid fa-check col-2 d-flex align-items-center"
                  style="color:#15E0DD"
                />
              </div>
            </div>
            <p 
              v-if="error" 
              class="text-danger text-center mt-3">Debe seleccionar un tamaño</p>
          </div>
          <div
            style="height: 50px;"
            class="mt-3"
          >
            <button
              class="btn py-2 w-100 rounded-3"
              style="background-color: #011638; font-size: 1.1rem;font-weight: 600; color: white"
              @click="submit()"
            >
              <span>Buscar garaje</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <spinner-component
      id="spinner"
      class="d-none"
      style="z-index: 100;"
    />
  </div>
</template>
<script>
  //import axios from 'axios';
  import SpinnerComponent from '../components/SpinnerComponent.vue'
  import TimeComponent from '../components/TimeComponent.vue'
  import L from 'leaflet';
  import 'leaflet.markercluster';
  import AddressBrowserComponent from '../components/AddressBrowserComponent.vue';
  //import { mapState } from 'vuex';
  //import router from '@/router';

  export default {
    name: 'RegisterPage',
    components:{
        SpinnerComponent,
        TimeComponent,
        AddressBrowserComponent
    },
    data: function() {
      return {
        isCollapsed: false,
        map: {},
        markers: L.markerClusterGroup(),
        step: 2,
        input: {
            address: {},
            time: {
              startTime: "08:00",
              endTime: "18:00"
            },
            weekend_full_day: false,
            vehicle_size: null,
        },
        error: null
      }
    },
    watch:{
        step(){
            switch(this.step){
                case 1:
                    this.isCollapsed=false;
                    break;
                case 2:
                    this.isCollapsed=true;
                    break;
                case 3:
                    this.isCollapsed=true;
                    break;
            }
        }
    },
    mounted(){
        this.map = L.map('map', {zoomControl: false,zoom:1,zoomAnimation:false,fadeAnimation:true,markerZoomAnimation:false, scrollWheelZoom: false, dragging: false})
        this.map.invalidateSize()
        this.map = this.map.setView([38.3436365, -0.4881708], 18)
        L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
            maxZoom: 20,
            minZoom: 1
        }).addTo(this.map);

    },
    methods:{
        handleGetAddress(address){
          this.isCollapsed = true;
          this.map.setView(address.center, 15)
          this.input.address.address = address.address
          this.input.address.center = address.center
          this.input.address.city = address.city

          const customIcon = L.icon({
              iconUrl: require("@/assets/driver_icon.png"), // Ruta a la imagen
              iconSize: [50, 50], // Tamaño del ícono
              iconAnchor: [20, 30], // Punto de anclaje (base del ícono)
              popupAnchor: [0, -40], // Punto del popup relativo al ícono
            });
          L.marker(address.center,{ icon: customIcon }).addTo(this.map);

          this.step = 2
        },
        handleGetDataHoras(time){
          console.log(this.input.time)
          this.input.time = time
        },
        submit(){
          if(this.input.vehicle_size == null){
            this.error=true
            return
          }
          const query = {
            ...this.input,
            address: JSON.stringify(this.input.address), // Serializa el objeto `address`
            time: JSON.stringify(this.input.time), // Serializa el objeto `time`
          };

          this.$router.push({
            name: 'parkers',
            query: query,
          });
        }

    }
  }
</script>
<style scoped>

.form-check-input{
    height: 20px !important;
}

.el-select__wrapper{
    padding: 0px;
    margin: 0px;
}



  .tab{
    height: 5px;
    margin-top: 10px;
    width: 13vw;
    background-color: #AAB1BD;
    border-radius: 100px;
  }

  #folding_tab{
    background-color: #F5F6F8 !important;
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    transition: height 0.5s ease;
    z-index: 100;
    position: absolute;
    width: 100vw;
  }

  #folding_tab.collapsed {
        height: 60vh;
        bottom: 0 !important;
    }

    #map {
        height: calc(40vh + 30px) ;
        width: 100vw;
        z-index: 0 !important
    }


    .form-check-input:checked {
        background-color: #15E0DD;
        border-color: #15E0DD;
    }
</style>
